import { render, staticRenderFns } from "./TreatmentInstructionDropdown.vue?vue&type=template&id=412041cc&scoped=true&lang=pug&"
import script from "./TreatmentInstructionDropdown.vue?vue&type=script&lang=js&"
export * from "./TreatmentInstructionDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentInstructionDropdown.vue?vue&type=style&index=0&id=412041cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412041cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDivider,VIcon,VMenu,VProgressCircular,VProgressLinear,VRow,VSheet,VTextField})
